import { useQuery } from '@tanstack/react-query'

import { GetAtendimentoAtivoService } from '@/features/atendimento/shared/http'
import { useLocalStorage } from '@/hooks'
import type { TAtendimento } from '@/types/atendimento'
import { atendimentoKeys } from '@/utils/atendimento-query-keys'

export const useAtendimentoAtivo = (enabled: boolean) => {
  const [_, setAtendimentoAtivo] = useLocalStorage<TAtendimento | null>('atendimento', null)
  return useQuery({
    queryKey: atendimentoKeys.atendimentoAtivo(),
    queryFn: async () =>
      new GetAtendimentoAtivoService().execute().then((response) => {
        setAtendimentoAtivo(response)
        return response
      }),
    retry: false,
    enabled,
  })
}
